import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// Components
import SearchSelectInputV2 from '../../../../../../common/src/components/SearchSelectInputV2';

// Types
import { ReturnOptionProps } from '../../../../../../../types/ProductFactory';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import useQuestionEnum from '../../../../hooks/useQuestionEnum';

interface Props {
  question: FlowsQuestion;
  isSmallDesktopDisplay?: boolean;
}

const SelectInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
  isSmallDesktopDisplay,
}) => {
  const {
    field: { onBlur, value },
    prefilled,
    error,
  } = useFlowInputComponent({ question });

  const { t } = useTranslation();

  const handleOnChange = ({ name, value }: ReturnOptionProps) => {
    onBlur({ name, value: value as string });
  };
  const options = useQuestionEnum(question);

  return (
    <SearchSelect
      placeholder={t('Choose an option')}
      name={question.id}
      onSelected={handleOnChange}
      options={options}
      error={error?.message}
      value={options.find(({ value: _value }) => value === _value)}
      prefilled={prefilled}
      dataTestId={`FLOWS_SELECT-INPUT_${question.id
        .toUpperCase()
        .replaceAll('.', '-')}`}
      menuPlacement={isSmallDesktopDisplay ? 'top' : 'auto'}
      sort={false}
      disabled={question.rules.is_disabled}
    />
  );
};

const SearchSelect = styled(SearchSelectInputV2)`
  width: 100%;
  height: unset;

  label > div {
    border-radius: 6px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06),
      0 0 1px rgba(0, 0, 0, 0.04);
    margin-bottom: 0;
    margin-top: 0;
  }
`;

export default SelectInputComponent;
